import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../../../components/CustomComponent.js";
export default class StockHistories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal_create: false,
      modal_update: false,

      filter_search: "",
      filter_start_date: "",
      filter_end_date: "",
      filter_warehouse_id: "",
      filter_category_id: "",

      data_warehouse: [],
      data_category: [],
      data: [],
      count: 10,

      id: "",
      uid: "",
      bank_name: "",
      account_number: "",
      account_name: "",

      visible: false,
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get(1);
   window.addEventListener("scroll", this.handleScroll);
  }
  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const { visible } = this.state;
    if (window.pageYOffset > 300 && !visible) {
      this.setState({ visible: true });
    } else if (window.pageYOffset <= 300 && visible) {
      this.setState({ visible: false });
    }
  };

scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  Get = async (page) => {
    let data, count, data_warehouse, data_category;
    loading(true);
    let [result_warehouse, result_category] = await Promise.all([
      GET("admin/setting/warehouses/list", { page: 0, data_search: "" }),
      GET("admin/setting/categories/list", { page: 0, data_search: "" }),
    ]);
    if (result_warehouse?.status) {
      data_warehouse = result_warehouse.data.map((e) => ({
        value: e.uid,
        label: e.name,
      }));
    }
    if (result_category?.status) {
      data_category = result_category.data.map((e) => ({
        value: e.uid,
        label: `${e.category_code} ${e.name}`,
        id: e.id,
        warehouse_id: e.warehouse.uid,
      }));
    }
    this.setState({
      data_warehouse,
      data_category,
    });
    loading(false);
  };
  GetData = async () => {
    const {
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_category_id,
    } = this.state;
    if (!filter_start_date) {
      alert("", "info", "แจ้งเตือน", "กรุณาเลือกวันที่เริ่มต้น");
      return;
    } else if (!filter_end_date) {
      alert("", "info", "แจ้งเตือน", "กรุณาเลือกวันที่สิ้นสุด");
      return;
    } 
    // else if (!filter_warehouse_id) {
    //   alert("", "info", "แจ้งเตือน", "กรุณาเลือกคลังสินค้า");
    //   return;
    // } else if (!filter_category_id) {
    //   alert("", "info", "แจ้งเตือน", "กรุณาเลือกหมวดหมู่");
    //   return;
    // }
    // const start = new Date(filter_start_date).getTime();
    // const end = new Date(filter_end_date).getTime();
    // const diff = Math.abs(end - start);

    // if (diff > 7 * 24 * 60 * 60 * 1000) {
    //   alert(
    //     "",
    //     "info",
    //     "แจ้งเตือน",
    //     "กรุณาเลือกวันเริ่มต้นสิ้นสุด ไม่เกิน 7 วัน"
    //   );
    //   return;
    // }
    loading(true);
    let body = {
      data_search: filter_search,
      start_date: filter_start_date
        ? format_date(filter_start_date, "yyyy-mm-dd", "en")
        : "",
      end_date: filter_end_date
        ? format_date(filter_end_date, "yyyy-mm-dd", "en")
        : "",
      warehouse_id: filter_warehouse_id,
      category_id: filter_category_id,
    };
    let result = await GET("admin/stock-activities/list-history", body);
    if (result?.status) {
      this.setState({ data: result.data, count: result.count });
    }
    loading(false);
  };
  render() {
    const {
      modal_create,
      modal_update,
      filter_search,
      filter_start_date,
      filter_end_date,
      filter_warehouse_id,
      filter_category_id,
      data_warehouse,
      data_category,
      data,
      count,
      id,
      uid,
      bank_name,
      account_number,
      account_name,
      visible
    } = this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar />
        <div className="body p-3">
          <div className="rounded-4 bg-white p-3">
            <div className="d-flex justify-content-between">
              <h4 className="fw-bold mb-3 me-3">ประวัติสต็อก</h4>
            </div>
            <div className="d-flex flex-wrap align-items-center">
              <input
                type="text"
                className="form-control wpx-200 me-2 mb-2"
                placeholder="ค้นหา ชื่อสินค้า..."
                onChange={(e) => {
                  this.setState({ filter_search: e.target.value });
                }}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    this.Get(1);
                  }
                }}
                value={filter_search}
              />
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_start_date: e.target.value });
                }}
                value={filter_start_date}
              />
              <span className="px-2 me-2 mb-2">ถึง</span>
              <input
                type="date"
                className="form-control wpx-200 me-2 mb-2"
                onChange={(e) => {
                  this.setState({ filter_end_date: e.target.value });
                }}
                value={filter_end_date}
              />
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="คลังสินค้า..."
                  options={data_warehouse}
                  onChange={(e) => {
                    this.setState({ filter_warehouse_id: e });
                  }}
                  value={filter_warehouse_id}
                />
              </div>
              <div className="wpx-200 me-2 mb-2">
                <Select
                  className="form-control"
                  placeholder="หมวดหมู่..."
                  options={data_category}
                  onChange={(e) => {
                    this.setState({ filter_category_id: e });
                  }}
                  value={filter_category_id}
                />
              </div>
              <div className="d-flex">
                <button
                  className="btn btn-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.GetData();
                  }}
                >
                  ค้นหา
                </button>
                <button
                  className="btn btn-outline-dark px-3 me-2 mb-2"
                  onClick={() => {
                    this.setState({
                      filter_search: "",
                      filter_start_date: "",
                      filter_end_date: "",
                      filter_warehouse_id: "",
                      filter_category_id: "",
                      data: [],
                    });
                  }}
                >
                  ล้างค่า
                </button>
              </div>
            </div>
            <div className="table-responsive">
              <table className="table rounded-3 overflow-hidden table-hover">
                <thead>
                  <tr>
                    <td className="text-nowrap">บันทึกที่อยู่จาก</td>
                    <td className="text-nowrap">เข้า/ออก</td>
                    <td className="text-nowrap">คลังสินค้า</td>
                    <td className="text-nowrap">รหัส/ชื่อสินค้า</td>
                    <td className="text-nowrap">Serial Number</td>
                    <td className="text-nowrap">อ้างอิง</td>
                    <td className="text-nowrap">บันทึกเมื่อ</td>
                    <td className="text-nowrap">ผู้บันทึก</td>
                    <td className="text-nowrap">หมายเหตุ</td>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr>
                      <td className="text-nowrap">{item.type || "-"}</td>
                      <td className={"text-nowrap" + 
                        (["เบิกสินค้า","เพิ่มจำนวน","รับสินค้า"].includes(item.type) ? " text-success": 
                        ["ลดจำนวน","ขายหน้าร้าน","ซ่อมให้ลูกค้า","ประกอบ","ซ่อมภายใน","คืนสินค้าให้ Sup"].includes(item.type) ? " text-danger": 
                        ["คืนสินค้า"].includes(item.type) && item.is_change ? " text-danger" : " text-success")}>
                          {["เบิกสินค้า","เพิ่มจำนวน","รับสินค้า"].includes(item.type) ? "+": 
                          ["ลดจำนวน","ขายหน้าร้าน","ซ่อมให้ลูกค้า","ประกอบ","ซ่อมภายใน","คืนสินค้าให้ Sup"].includes(item.type) ? "-": 
                          ["คืนสินค้า"].includes(item.type) && item.is_change ? "-": "+"}
                          {item.qty || "-"}</td>
                      <td className="text-nowrap">{item.warehouse_name || "-"}</td>
                      <td className="text-nowrap">{item.product_code} {item.product_name}</td>
                      <td className="text-nowrap">{item.serial_number || "-"}</td>
                      <td className="text-nowrap">{item.document_no || "-"}</td>
                      <td className="text-nowrap">{item.created_at ? format_date(item.created_at,"dd/mm/yyy hh:mm") : ""}</td>
                      <td className="text-nowrap">{item.created_by || "-"}</td>
                      <td className="text-nowrap">{item.remark || "-"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
           {visible && (
            <button
              className="position-fixed btn btn-primary"
              onClick={() => {
                this.scrollToTop();
              }}
              style={{ top: 30, right: 30 }}
            >
              กดเพื่อไปยังด้านบน
            </button>
          )}
        </div>
      </div>
    );
  }
}
